
module Sxc.Site {
    export class VideoPlayer {
        private roomlist;

        constructor(roomlist) {
            this.roomlist = roomlist;
            this.initShakaPlayer();
        }

        public async canPlayVideoWithDash(){
            let thisref=this;
            if(typeof window.MediaSource!=="undefined" && window.MediaSource!=null){
                try{
                    await navigator.requestMediaKeySystemAccess(
                        "org.w3.clearkey",
                        [{videoCapabilities: [{contentType: 'video/mp4; codecs="avc1.4d002a"'}]}]
                    ).then((x)=>{
                        console.debug(x);
                        thisref.roomlist.canPlayVidWithDash=true;
                    });
                }
                catch (e){
                    console.debug(e);
                    thisref.roomlist.canPlayVidWithDash=false;
                }

            }else{
                console.debug("No window.MediaSource obj");
                thisref.roomlist.canPlayVidWithDash=false;
            }
        }

        public initShakaPlayer(){
            if (shaka.Player.isBrowserSupported()) {
                shaka.polyfill.installAll();
                this.roomlist.shakaPlayer = new shaka.Player();
                this.roomlist.shakaPlayer.addEventListener('error', function (e){ console.error(e);});
                this.roomlist.shakaPlayerTeaser = new shaka.Player();
                this.roomlist.shakaPlayerTeaser.addEventListener('error', function (e){ console.error(e);});
            } else {
                console.debug('ShakaPlayer: Browser not supported!');
            }
            this.canPlayVideoWithDash();
        }

        public async playVideoWithDashOrHls(drmobj:any,token:string,videoobj:any,shakaplayerobj:shaka.Player,fallbackurl){
            let thisref=this;
            if(this.roomlist.shakaPlayer != null){
                shakaplayerobj.attach(videoobj);
                //videoobj['ui'].configure( {  'overflowMenuButtons' : ['cast', 'airplay', 'playback_rate', 'picture_in_picture'] });
                // @ts-ignore
                //ui = new shaka.ui.Overlay(shakaplayerobj, $(videoobj).parent()[0], videoobj);//videoModal
                // @ts-ignore
                //ui.configure( {  'overflowMenuButtons' : ['playback_rate', 'picture_in_picture'] });
            }

            $.ajax({
                url: drmobj.getKey+"&tokenID="+token,
                dataType: 'json',
                xhrFields: { withCredentials: true }
            }).done((videoData) => {
                if(thisref.roomlist.canPlayVidWithDash && typeof videoData.drm != "undefined"){
                    thisref.roomlist.helpers.log("playing with drm");
                    //videoobj.controls = false
                    shakaplayerobj.configure(videoData);
                    shakaplayerobj.addEventListener('error', (error) => {
                        if (error instanceof Error) {console.error("Shaka Error: ", error);
                        }// @ts-ignore
                        if (error.severity === shaka.util.Error.Severity.CRITICAL) { console.error("Shaka Error fatal: ", error);
                        } else {
                            console.error("Shaka Error non-fatal: ", error);
                            // @ts-ignore
                            if(typeof error.detail.data[1].message !== "undefined" && error.detail.data[1].message.indexOf("Failed to fetch")!==-1){
                                console.error( "Failback to mp4");
                                videoobj.controls = true;
                                videoobj.src = fallbackurl;
                                videoobj.load();
                                videoobj.play();
                            }
                        }
                    });
                    shakaplayerobj.load(drmobj.dash).then(function() { }).catch(function(err){console.error(err)});
                    let track = videoobj.textTracks[0];track.mode = 'disabled';
                }else{//hls ios, safari
                    videoobj.controls = true;
                    if(thisref.roomlist.helpers.isiOS()  && videoobj.canPlayType('application/vnd.apple.mpegurl')){
                        thisref.roomlist.helpers.log("playing with hls - ios "+drmobj.hls);
                        shakaplayerobj.load(drmobj.hls).then(function() { }).catch(function(err){console.error(err)});
                    }else{
                        videoobj.src = fallbackurl;
                        videoobj.load();
                        videoobj.play();
                    }
                }
                setTimeout(()=>{videoobj.play();},300);
            });
        }

    }
}